
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入公司名称查询" v-model="topQueryParam.companyName"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
<!--                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>-->
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator"  style="margin-top: 5px">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <a-button @click="batchDel" icon="delete">删除</a-button>
          <a-button @click="exportdata" icon="export">导出</a-button>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :scroll="{ x: true }"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            @change="handleTableChange">

            <span slot="state" slot-scope="text, record">
              <span v-if="record.state == 1">aadfadfsdf</span>
              <span v-if="record.state == 2">asdfadf</span>
            </span>

            <span slot="settlementMethod" slot-scope="text, record">
              <span v-if="record.settlementMethod == 0">月结</span>
              <span v-if="record.settlementMethod == 1">寄付现结</span>
              <span v-if="record.settlementMethod == 2">到付</span>
            </span>

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="delConfirm(handleDelete,record.id)">删除</a>

            </span>
            <!-- 状态渲染模板 -->
            <template slot="customRenderFlag" slot-scope="enabled">
              <a-tag v-if="enabled==1" color="green">启用</a-tag>
              <a-tag v-if="enabled==0" color="orange">禁用</a-tag>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
      </a-card>
    </a-col>
    <undertakeAdd ref="modalForm" @ok="modalFormOk"></undertakeAdd>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JDate from '@/components/jeecg/JDate'
import undertakeAdd from './undertakeAdd.vue'
import { PIadmin } from '@api/manage'
import { getNowFormatStr } from '@/utils/util'
export default {
  name: "FunctionList",
  mixins:[JeecgListMixin],
  components: {
    JDate,
    undertakeAdd
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },

      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },

        {title: '公司名称 ', dataIndex: 'companyName',},
        {title: '统一社会信用代码', dataIndex: 'unifiedSocialCreditCode', ellipsis:true},
        {title: '联系人', dataIndex: 'contactName',},
        {title: '联系电话', dataIndex: 'contactPhone',ellipsis:true},
        {title: '结算方式', dataIndex: 'settlementMethod',  ellipsis:true,scopedSlots: { customRender: 'settlementMethod'}},
        {title: '承运人', dataIndex: 'carrierName',ellipsis:true},
        {title: '承运人电话', dataIndex: 'carrierPhone',},
        // {
        //   title: '状态', dataIndex: 'state',align: "center",
        //   scopedSlots: { customRender: 'state' }
        // },
        {title: '备注', dataIndex: 'remark',},
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          align:"center",
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: "/carrier/carrierManagement/list",
        delete: "/carrier/carrierManagement/delete",
        deleteBatch: "/carrier/carrierManagement/deleteBatch"
      }
    }
  },
  computed: {

  },
  methods: {
    exportdata(){
      const fileName = '承运信息'
      let url = '/carrier/carrierManagement/exportXls'
      PIadmin(url, {ids:this.selectedRowKeys.join(',')}).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', ( fileName + '_' + getNowFormatStr() + '.xls'))
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) //下载完成移除元素
        window.URL.revokeObjectURL(url) //释放掉blob对象
      })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>